var render = function render(_c,_vm){return _c('div',{staticClass:"spinner"},[_c('span',{staticClass:"font-blank"},[_vm._v("Loading...")]),_vm._v(" "),_c('fa',{attrs:{"icon":"circle-notch"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }